














import { Component, Prop, Watch } from 'vue-property-decorator';

import { Store } from '@/enums/Store';

import { Member } from '@/util/Member';
import { Option } from '@/util/Option';
import { User } from '@/util/User';

import { namespace } from 'vuex-class';

import FormGroup from '@/components/Form/InputComponents/FormGroup.vue';
import FormSelect from '@/components/Form/InputComponents/FormSelect.vue';
import Validatable from '@/components/Validatable.vue';

const MEMBER = namespace(Store.MEMBER);
const CUSTOMER = namespace(Store.CUSTOMER);
const INVOICE_RECIPIENT = namespace(Store.INVOICE_RECIPIENT);

@Component({
  components: { FormSelect, FormGroup }
})
export default class CustomerSelection extends Validatable {
  @Prop({ required: true }) toggle!: boolean;
  @CUSTOMER.State('customer') customer?: User;
  @CUSTOMER.Action('setCustomer') setCustomer!: (id?: string) => void;
  @CUSTOMER.Action('unsetCustomer') unsetCustomer!: () => void;
  @MEMBER.State('members') members!: Member[];
  @INVOICE_RECIPIENT.State('invoiceRecipient') invoiceRecipient?: User;

  @Watch('invoiceRecipient')
  updateOptions() {
    this.setCustomerOptions();
  }

  @Watch('toggle')
  updateCustomer() {
    if (this.customerSync) {
      this.customerSync = undefined;
    }
  }

  customerOptions: Option[] = [];

  created(): void {
    this.setCustomerOptions();
  }

  setCustomerOptions() {
    this.customerOptions = [];
    for (const member of this.members) {
      if (this.invoiceRecipient && this.invoiceRecipient.id === member.id) {
        continue;
      }

      const option = new Option(`${member.firstname} ${member.lastname}`, member.id);

      this.customerOptions.push(option);
    }

    if (this.customerOptions.length == 0) {
      this.unsetCustomer();
    }
  }

  set customerSync(id: string | undefined) {
    this.setCustomer(id);
  }

  get customerSync() {
    if (this.customer) {
      return this.customer.id;
    }
    return undefined;
  }
}
